import ClearSuggestedReply from 'actions/suggested_replies/clear_suggested_reply';
import { SidePanelType } from 'models/side_panel';

export default class CloseAnswerPanel {
  constructor(context) {
    this.context = context;
  }

  run({ customerId, conversationId, compositionId }) {
    const answerPanel = this.context.stores.answerPanel.get();
    answerPanel.clearAnswer();
    answerPanel.clearHistory();
    answerPanel.clearSearchResult();
    this.context.stores.answerPanel.set(answerPanel);

    const sidePanel = this.context.stores.sidePanel.get();
    if (sidePanel.isShowing(SidePanelType.ANSWER)) {
      sidePanel.close();
      this.context.stores.sidePanel.set(sidePanel);

      const commentPanel = this.context.stores.commentPanel.get();
      commentPanel.clearItemId();
      this.context.stores.commentPanel.set(commentPanel);
    }

    this.context.stores.snippetSearchResult.remove();
    this.context.executeAction(ClearSuggestedReply, { customerId });
    this.context.analytics.track('Answer Panel Closed', { customerId, conversationId, compositionId });
  }
}
